module.exports = __webpack_public_path__ + "static/media/iitd-incubated.5e6f82f8.jpg";